import { axios, handleError } from '../axios';

export const getRobotSetting = () => {
  // Return a promise that resolves to a name->object map
  return new Promise((resolve, reject) => {
    axios
      .get('admin/setting/robot/get')
      .then((response) => {
        try {
          // Expecting response.data.data to be an array of objects
          const list = Array.isArray(response?.data?.data) ? response.data.data : [];

          // Build a map: name -> full object
          const map = list.reduce((acc, item) => {
            if (item && typeof item.name === 'string' && item.name.length > 0) {
              acc[item.name] = item; // keep the whole object as value
            }
            return acc;
          }, {});

          resolve(map);
        } catch (err) {
          console.error(err?.message || err);
          reject(err);
        }
      })
      .catch((e) => {
        // You can still use your handleError, but also reject to propagate the error
        handleError(e);
        reject(e);
      });
  });
};
